export default __webpack_public_path__ + "static/media/sheets.090a4f88.svg";